"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var InsuranceResource = /** @class */ (function (_super) {
    tslib_1.__extends(InsuranceResource, _super);
    function InsuranceResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InsuranceResource.endpoint = '/insurances';
    InsuranceResource.MODEL_NAME = 'insurance';
    return InsuranceResource;
}(base_1.default));
exports.default = InsuranceResource;
//# sourceMappingURL=insurance.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/insurance.js
// module id = DPn/
// module chunks = 0